export default function trimUnits(value) {
  return value.match(/(\d+(\.\d+)?)/)[0]
}